import { Button, Header, Message, Modal } from '@mairistem/composants';

type ModalArreteRegisseurProps = {
  onClose: () => void;
  hasReglements?: boolean;
};

const ModalArreteRegisseur = (props: ModalArreteRegisseurProps) => {
  const { onClose, hasReglements = false } = props;

  return (
    <Modal open style={{ width: 'fit-content' }}>
      <Modal.Header>Arrêté de régie</Modal.Header>
      <Modal.Content>
        <Header as="h4">
          <Header.Content>
            Vous devez procéder à l&apos;arrêté de votre régie au moins une fois par mois.
            {hasReglements && (
              <>
                <br />
                <Message error size="small">
                  <Message.Header>
                    Il reste des règlements à contrôler pour génération des bordereaux de remise.
                  </Message.Header>
                </Message>
              </>
            )}
          </Header.Content>
        </Header>
      </Modal.Content>
      <Modal.Actions>
        <Button basic content="Fermer" onClick={onClose} />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalArreteRegisseur;
